import { literaStorageKeys } from './litera-storage'
import { getActiveStorageUserId } from './user-storage-scope'

/** Keep LITRA localStorage project id aligned with the active library book. */
export function literaProjectStorageKey(userId?: string | null): string {
  const uid = userId || getActiveStorageUserId()
  if (!uid) return 'bbg-litera-project-id'
  return literaStorageKeys(uid).projectId
}

/** @deprecated use literaProjectStorageKey */
export const LITERA_PROJECT_STORAGE_KEY = 'bbg-litera-project-id'

export function literaProjectIdFromLibraryRecord(record: {
  id?: string | null
  book?: { literaProjectId?: string | null } | null
} | null | undefined): string | null {
  const fromBook = record?.book?.literaProjectId
  if (fromBook && String(fromBook).trim()) return String(fromBook).trim()
  const id = record?.id
  if (typeof id === 'string' && id.startsWith('litera-')) {
    return id.slice('litera-'.length)
  }
  return null
}

export function syncLiteraProjectToStorage(
  projectId: string | null | undefined,
  userId?: string | null,
): void {
  if (!projectId) return
  const uid = userId || getActiveStorageUserId()
  if (!uid) return
  try {
    localStorage.setItem(literaStorageKeys(uid).projectId, projectId)
  } catch {
    /* ignore quota / private mode */
  }
}
